export enum InputSearchSize {
  RG = 'rg',
  MD = 'md',
  SM = 'sm',
}

export enum InputSearchFailedType {
  None = 'none',
  Error = 'error',
  Warning = 'warning',
}

export enum InputSearchAction {
  Typified = 'typified',
  Button = 'button'
}
